/**
 * Cart upsell — add to cart from the upsell cards in the cart drawer / cart page.
 * Uses event delegation so it keeps working after Dawn re-renders the cart.
 */
(function () {
  if (window.__cartUpsellInit) return;
  window.__cartUpsellInit = true;

  function cartAddUrl() {
    return (window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js';
  }

  // Variant select → update price
  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('select[data-cu-variant]');
    if (!select) return;
    var card = select.closest('[data-cart-upsell-card]');
    var opt = select.options[select.selectedIndex];
    var price = card.querySelector('[data-cu-price]');
    var compare = card.querySelector('[data-cu-compare]');
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    if (compare) {
      compare.textContent = opt.dataset.compare || '';
      compare.hidden = !opt.dataset.compare;
    }
  });

  // Add to cart
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-cu-add]');
    if (!btn) return;
    e.preventDefault();

    var card = btn.closest('[data-cart-upsell-card]');
    var wrapper = btn.closest('[data-cart-upsell]');
    var variantEl = card.querySelector('[data-cu-variant]');
    var errorEl = card.querySelector('[data-cu-error]');
    var variantId = variantEl && parseInt(variantEl.value, 10);
    if (!variantId) return;

    var context = wrapper ? wrapper.dataset.context : 'drawer';
    var drawer = document.querySelector('cart-drawer');

    btn.setAttribute('aria-busy', 'true');
    if (errorEl) errorEl.hidden = true;

    var body = { items: [{ id: variantId, quantity: 1 }] };
    if (context === 'drawer' && drawer) {
      body.sections = ['cart-drawer', 'cart-icon-bubble'];
      body.sections_url = window.location.pathname;
    }

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (r) {
        if (!r.ok || r.data.status) {
          throw new Error(r.data.description || r.data.message || 'Could not add to cart');
        }

        if (context === 'drawer' && drawer && typeof drawer.renderContents === 'function' && r.data.sections) {
          // Dawn re-renders the whole drawer (items, upsell, totals) from the returned section HTML
          var item = r.data.items && r.data.items[0];
          drawer.renderContents({ id: item ? item.id : variantId, sections: r.data.sections });
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: r.data });
          }
        } else {
          // Cart page: reload so items, upsell, totals and app discounts (Kaching) are all fresh
          window.location.reload();
        }
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        }
      });
  });
})();
